import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
import { BlobBackground } from './BlobBackground';
export function WhyFailed() {
  return <section className="py-24 relative overflow-hidden" data-id="element-221">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-20 z-0 pointer-events-none" data-id="element-222">
        <BlobBackground color="var(--color-mint)" data-id="element-223" />
      </div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-224">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-225">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-226">
            Por qué las dietas "saludables" ya no te funcionan
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-227">
            Lo que funcionaba a los 30, ahora es gasolina para el fuego.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-228">
          <motion.div className="bg-white/80 backdrop-blur-sm p-10 rounded-3xl shadow-sm border border-sage/20 relative overflow-hidden" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-229">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-230">
              <XCircleIcon size={100} data-id="element-231" />
            </div>
            <h3 className="text-2xl font-serif mb-4 flex items-center gap-3" data-id="element-232">
              <span className="text-sage" data-id="element-233">01.</span> Alimentos "Sanos"
            </h3>
            <p className="text-charcoal/80 leading-relaxed" data-id="element-234">
              Las dietas genéricas incluyen alimentos que el sistema digestivo
              de 45+ años ya no procesa bien. Estás comiendo "limpio", pero tu
              cuerpo lo ataca como a un invasor, generando inflamación
              silenciosa.
            </p>
          </motion.div>

          <motion.div className="bg-white/80 backdrop-blur-sm p-10 rounded-3xl shadow-sm border border-sage/20 relative overflow-hidden" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-235">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-236">
              <AlertTriangleIcon size={100} data-id="element-237" />
            </div>
            <h3 className="text-2xl font-serif mb-4 flex items-center gap-3" data-id="element-238">
              <span className="text-sage" data-id="element-239">02.</span> Suplementos Mágicos
            </h3>
            <p className="text-charcoal/80 leading-relaxed" data-id="element-240">
              Pastillas, tés detox y polvos caros solo ocultan el síntoma
              temporalmente sin apagar el fuego interno. Es como tomar un
              analgésico mientras mantienes la mano en la estufa caliente.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}